// Tiny global toast bus — showToast() from anywhere; ToastHost (mounted once
// in the Shell) renders the stack bottom-right. No state library needed.
const listeners = new Set()
let counter = 0

// { title, body?, tone: 'progress' | 'success' | 'warn' | 'error', duration? }
export function showToast(toast) {
  const t = { id: `t${++counter}`, duration: 5500, tone: 'success', ...toast }
  listeners.forEach((fn) => fn(t))
  return t.id
}

export function onToast(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
